const DESKTOP_MEDIA_QUERY = "(min-width: 48rem)";

/**
 * Collapses the RWE club menu below the desktop breakpoint.
 */
export function initClubMenu(context) {
  once("titan-rwe-club-menu", "#block-titan-rwe-vereinsmenu", context).forEach(
    (menu) => {
      const toggle = menu.querySelector(".club-menu__toggle");
      const content = menu.querySelector(".club-menu__content");

      if (!toggle || !content) {
        return;
      }

      const desktopMediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);

      const setOpen = (isOpen) => {
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        content.hidden = !isOpen;
      };

      const syncWithViewport = (event) => {
        setOpen(event.matches);
      };

      menu.classList.add("club-menu--js");
      syncWithViewport(desktopMediaQuery);

      toggle.addEventListener("click", () => {
        const isOpen = toggle.getAttribute("aria-expanded") === "true";

        setOpen(!isOpen);
      });

      menu.addEventListener("keydown", (event) => {
        const isOpen = toggle.getAttribute("aria-expanded") === "true";

        if (event.key !== "Escape" || desktopMediaQuery.matches || !isOpen) {
          return;
        }

        setOpen(false);
        toggle.focus();
      });

      desktopMediaQuery.addEventListener("change", syncWithViewport);
    },
  );
}
